import { render, staticRenderFns } from "./Stock.vue?vue&type=template&id=1d55170c&scoped=true&"
import script from "./Stock.vue?vue&type=script&lang=js&"
export * from "./Stock.vue?vue&type=script&lang=js&"
import style0 from "./Stock.vue?vue&type=style&index=0&id=1d55170c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d55170c",
  null
  
)

export default component.exports